var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"wloading"},_vm._l((_vm.numbers),function(n,key){return _c('img',{key:key,staticClass:"loading",attrs:{"src":require("@/assets/loading.gif")}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }